import run from '../../utilities/run';
import $ from 'jquery';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

run("#bundle-detail", ()=> {
  const bundleDetailsPage = $("#bundle-detail");
  const activateBtn = $("#activate-btn");
  const activateItemUrl = bundleDetailsPage.data("activate-item-url");
  const deleteItemUrl = bundleDetailsPage.data("delete-item-url");
  const currentUrl = bundleDetailsPage.data("current-url");
  const itemStatus = bundleDetailsPage.data("item-status");
  const activateModalTitleTxt = bundleDetailsPage.data("activate-modal-title-txt");
  const activateModalBodyTxt = bundleDetailsPage.data("activate-modal-body-txt");
  const activateModalBtnTxt = bundleDetailsPage.data("activate-modal-btn-txt");
  const inactivateModalTitelTxt = bundleDetailsPage.data("inactivate-modal-title-txt");
  const inactivateModalBodyTxt = bundleDetailsPage.data("inactivate-modal-body-txt");
  const inactivateModalBtnTxt = bundleDetailsPage.data("inactivate-modal-btn-txt");

  activateBtn.click(function(e) {
    e.preventDefault();
    if (itemStatus.includes("Active")) {
      updateItem(inactivateModalTitelTxt, inactivateModalBodyTxt, inactivateModalBtnTxt, deleteItemUrl);
    } else {
      updateItem(activateModalTitleTxt, activateModalBodyTxt, activateModalBtnTxt, activateItemUrl);
    }
  });

  function updateItem(title, body, btn, url) {
    const submitModalFlow = new SubmitModalFlow({
      confirmModalTitle: title,
      confirmModalBody: `<div class="q-pad-all-xl">${body}</div>`,
      confirmModalBtnText: btn,
      onConfirmClick: function() {
        submitModalFlow.showLoadingModal();
        $.ajax({ 
          url: url,
          success: function(data) { 
            if (data.match("success")) {
              submitModalFlow.showSuccessModal();
              setTimeout(function() {
                location.href = currentUrl;
              }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
            } else {
              submitModalFlow.showFailureModal();
            }
          },
          error: function() {
            submitModalFlow.hideAllModals();
          }
        }); 
      }
    });
    submitModalFlow.init();
    submitModalFlow.showConfirmModal();
  }

});


// WEBPACK FOOTER //
// ./src/pages/products/bundleDetailsPage.js